import React, { useState } from "react";
import "./ProductCard.css";
import { Link, useNavigate } from "react-router-dom";
import { favoriteCheck, setFavorite } from "../../../axios";
import { toast } from "react-toastify";

const ProductCard = ({ item, hover, discount, link, commingSoon }) => {
  const navigate = useNavigate();
  const [hoverTakhfif, setHoverTakhfif] = useState(false);

  const addToFavorite = (e, id) => {
    e.preventDefault();

    if (localStorage.getItem("login")) {
      favoriteCheck(id, localStorage.getItem("phonenumber")).then(
        ({ data }) => {}
      );
      setFavorite(id, localStorage.getItem("phonenumber")).then(({ data }) => {
        toast.success("به لیست علاقه مندی ها اضافه شد");
      });
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  return (
    <Link to={link}>
      <div
        className="book"
        style={{ cursor: "pointer" }}
      >
        <ul className="inner-book">
          {discount && (
            <span
              className={`${
                hoverTakhfif && hover ? "darsad-takhfif-hover" : "darsad-takhfif"
              }`}
            >
              {Math.ceil(Number(discount) - 0.01)}%
            </span>
          )}
          {/* {!commingSoon && (
            <Link
              className={`${
                hoverTakhfif && hover ? "add-to-favorite" : "add-to-favorite"
              }`}
              onClick={(e) => {
                addToFavorite(e, item.id);
                e.stopPropagation();
              }}
              title="افزودن به علاقه‌مندی‌ها"
            >
              <i
                className="fa fa-heart-o"
                aria-hidden="true"
                style={{ color: "white" }}
              ></i>
            </Link>
          )} */}
          <div className="img w-50" style={{ paddingTop: "calc(1.07 * 100%)" }}>
            <img src={item.img} alt="product_image" />
          </div>
          <li className="page"></li>
          <li className="page page-2"></li>
          <li className="page page-3"></li>
          <li className="page page-4"></li>
          <li className="page page-5"></li>
          <li
            onMouseOver={() => setHoverTakhfif(true)}
            onMouseLeave={() => setHoverTakhfif(false)}
            className={
              hover === true ? "img final-page " : "img final-pageNohover"
            }
            style={{ paddingTop: "calc(134%)" }}
          >
            <img src={item.img} alt="product_image" />
          </li>
        </ul>
      </div>
    </Link>
  );
};

export default ProductCard;
